<header class="border-outlineVariant bg-surface slide-in-left-enter sticky top-0 z-20 flex h-[60px] w-full items-center border-b px-4! shadow-sm">
  <div class="flex w-full items-center justify-between gap-[30px]">
    <div class="flex items-center">
      <div class="title flex items-center">
        @if (isOffline()) {
        <mat-icon> cloud_off </mat-icon>
        }
        <h6 class="text-title-large text-fade-transition">{{ fullTitle() }}</h6>
      </div>
    </div>
    <div class="flex items-center gap-4">
      <ul class="flex items-center">
        <li>
          <a
            matTooltip="{{ 'SENSOR_EDIT.SETTINGS' | transloco }}"
            [matTooltipPositionAtOrigin]="true"
            [matTooltipPosition]="'below'"
            class="hover:bg-hoverOverlay focus:bg-focusOverlay active:bg-focusOverlay h-fit"
            [routerLink]="['/settings']"
            mat-icon-button
          >
            <mat-icon class="text-onSurfaceVariant">settings</mat-icon>
          </a>
        </li>
        <li>
          <a
            matTooltip="{{ helplabel() }}"
            [matTooltipPositionAtOrigin]="true"
            [matTooltipPosition]="'below'"
            class="hover:bg-hoverOverlay focus:bg-focusOverlay active:bg-focusOverlay h-fit"
            mat-icon-button
            (click)="openSupportRequestDialog()"
          >
            <mat-icon class="text-onSurfaceVariant">contact_support</mat-icon>
          </a>
        </li>
        <li class="h-min-touch w-min-touch p-2.5">
          <div
            class="bg-onSurfaceVariant flex h-full grow-0 items-center justify-center rounded-full font-normal text-white"
            [ngStyle]="{
              'background-size': 'contain',
              'background-image': 'url(' + (profilePicture$ | async) + ')'
            }"
          >
            @if ((profilePicture$ | async) === null) {
            <span>{{ initalizes$ | async }}</span>
            }
          </div>
        </li>
      </ul>
      <div class="header-logo"></div>
    </div>
  </div>
</header>
